var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.702 9.1 3.557-3.55q.303-.3.72-.3.415 0 .718.3t.303.713q0 .412-.303.712l-4.289 4.25q-.303.3-.706.3-.404 0-.707-.3L14.851 9.1a.97.97 0 0 1-.303-.712q0-.413.303-.713t.706-.3q.405 0 .707.3zm-8.629 2.825q-1.665 0-2.85-1.175T5.036 7.925 6.222 5.1t2.851-1.175T11.924 5.1t1.186 2.825-1.186 2.825-2.85 1.175m-8.073 6v-.8q0-.85.442-1.562a2.93 2.93 0 0 1 1.173-1.088 15 15 0 0 1 3.179-1.162 14 14 0 0 1 3.28-.388q1.665 0 3.28.387 1.614.388 3.178 1.163.732.375 1.173 1.088.442.712.442 1.562v.8q0 .825-.593 1.412-.592.588-1.426.588H3.018q-.833 0-1.425-.588A1.92 1.92 0 0 1 1 17.926m2.018 0h12.11v-.8a.93.93 0 0 0-.138-.5 1 1 0 0 0-.366-.35 13.2 13.2 0 0 0-2.75-1.012 11.8 11.8 0 0 0-5.601 0q-1.388.337-2.75 1.012a1 1 0 0 0-.366.35.93.93 0 0 0-.139.5zm6.055-8q.832 0 1.426-.587.593-.588.593-1.413t-.593-1.412a1.95 1.95 0 0 0-1.426-.588q-.832 0-1.425.588a1.92 1.92 0 0 0-.593 1.412q0 .824.593 1.413.592.587 1.425.587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheck);
export default __webpack_public_path__ + "static/media/person_check.284d95b23e257c23f49d2d15a214d3ad.svg";
export { ForwardRef as ReactComponent };